import React, { useEffect, useState, useContext } from 'react';
import { DialogAction, useModal } from '../../../../../function/useModal';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  Typography,
} from '@material-ui/core';
import SimpleDialog from '../../../../atoms/Dialog/SimpleDialog';
import { useTranslation } from 'react-i18next';
import { SettingsState } from '../../../../organisms/SelectSettings';
import { NAME_DEV_SET, GetNameDevSetRow, SetNameDevSetRow } from '../../../../../function/NameDevSetModel';
import ConfirmDialog, { ConfirmDialogResponse } from '../../../../atoms/Dialog/ConfirmDialog';
import MessageDialog, { MessageDialogResponse } from '../../../../atoms/Dialog/MessageDialog';
import { ErrorCode } from '../../../../../ErrorCode';

import { DeviceRegistPageStyle, TableBaseStyle } from '../DeviceRegistStyle';
import LayerShortSettingDialogBody from './LayerShortSettingDialogBody';
import { SetJudgeSettingLayerShort } from '../../../../../function/JudgeSettingSelectModel';

export type LayerShortSettingDialogProps = {
  editData: SettingsState;
};

export type LayerShortSettingDialogResponse = { devindex: number; };


const LayerShortSettingDialog: React.FC<LayerShortSettingDialogProps> = (props: LayerShortSettingDialogProps) => {
  const { t } = useTranslation();
  const pageStyle = DeviceRegistPageStyle();
  const [flgCfmDlg, actCfmDlg] = useModal<ConfirmDialogResponse>();
  const [flgMsgDlg, actMsgDlg] = useModal<MessageDialogResponse>();

  const [dlgmsg, setDlgmsg] = useState<string>('');
  const [isUpdateDisp, setIsUpdateDisp] = useState<boolean>(false);
  const [devRow, setDevRow] = useState<NAME_DEV_SET>({
    DEV_INDEX: 0,
    EST: 0,
    DEV_NO: '',
    DEV_NAME: '',
    FLG_MOTOR: 0,
    REV_VAL: 0,
    RATED_CUR: 0,
    BEARING_LD: '',
    BEARING_ANTI_LD: '',
    RATED_SPEED: 0,
    RATED_POWER: 0,
    POLE: 0,
    VOLTAGE: 0,
    PWR_FREQ: 0,
    EXC_CUR: 0,
    INV_FREQ: 0,
    WEALTH: 0,
    START_JDG_CUR: 0,
    NOTE: '',
    CAREER_MASK: 0,
    WAV_MAKE: 0,
    INV_DRV_ON: 0,
    EMC_TYPE: 0,
    SMOOTH_W0: 0,
    SMOOTH_W1: 0,
    SMOOTH_W2: 0,
    TH_SIGMA: 0,
    TH_L_R: 0,
    TH_L_S: 0,
    TH_L_T: 0,
    TH_H_R: 0,
    TH_H_S: 0,
    TH_H_T: 0,
    SPD_UP_FREQ: 0,
    SPD_LO_FREQ: 0,
    DSP_UP_FREQ: 0,
    DSP_LO_FREQ: 0,
    startJdgCurPer: 0,
  });

  const [buttonEnable, setButtonEnable] = useState<boolean>(true);



  const cfmdlg = flgCfmDlg ? (
    <ConfirmDialog
      dialog={actCfmDlg}
      message={dlgmsg}
      action={t('CollectSetting.はい', 'はい')}
      cancel={t('CollectSetting.いいえ', 'いいえ')}
    />
  ) : null;
  const msgdlg = flgMsgDlg ? <MessageDialog dialog={actMsgDlg} message={dlgmsg} /> : null;

  console.debug('loop count', devRow);
  // useEffect(() => {
  //   /** 初期設定 */
  //   // setDevNo(1);
  //   // setItemName(1);
  //   console.debug(['LayerShortSettingDialog useEffect Check devIndex No', props.editData.selectIndexNo]);
  // }, []);

  /**
   * NAME_DEV_SETテーブルからデータを取得
   */
  useEffect(() => {
    setButtonEnable(false);
    GetNameDevSetRow(props.editData.selectIndexNo !== undefined ? props.editData.selectIndexNo : 0)
      .then((res) => {
        if (res !== undefined) {
          console.debug(['GetNameDevSetRow check', res]);
          setDevRow(res);
        }
        props.editData.IsUpdate = false;
        setButtonEnable(true);
      })
      .catch((e) => {
        setDlgmsg(t('LayerShortSettingDialog.データ取得中にエラーが発生しました', 'データ取得中にエラーが発生しました'));
        actMsgDlg.open();
      })
      .finally(() => {

        setButtonEnable(true);
      });
  }, []);//isUpdateDisp, props.editData.CancelCondition

  /**
   * タブ遷移時の保存
   */
  useEffect(() => {
    props.editData.SaveFunction = saveAction2;
    props.editData.IsUpdate = false;
  }, [props.editData.CancelCondition]);

  /**
   * NAME_DEV_SETの更新処理
   * @param item
   */
  const updateDev = (item: NAME_DEV_SET) => {
    if (item.DEV_INDEX === devRow.DEV_INDEX) {
      setDevRow(item);
      props.editData.Target = item;
      props.editData.IsUpdate = true;
    }
  };

  /**
   * キャンセル処理
   */
  const cancelAction = () => {
    //編集済みの場合確認する
    if (props.editData.IsUpdate) {
      setDlgmsg(
        t(
          'LayerShortSettingDialog.保存していないデータを破棄しますよろしいですか',
          '保存していないデータを破棄します。\nよろしいですか?'
        )
      );
      actCfmDlg
        .open()
        .apply((_) => {
          props.editData.IsUpdate = false;
          console.debug(t('LayerShortSettingDialog.実行', '実行'));

          if (props.editData.CloseDialog !== undefined) {
            console.debug('LayerShortSettingDialog closeAction complete');
            props.editData.CloseDialog();
          }
          else {
            console.debug('LayerShortSettingDialog closeAction failuer');
          }

        })
        .cancel(() => {
          console.debug(t('LayerShortSettingDialog.キャンセル', 'キャンセル'));
        });
    } else {
      if (props.editData.CloseDialog !== undefined) {
        console.debug('LayerShortSettingDialog closeAction complete');
        props.editData.CloseDialog();
      }
      else {
        console.debug('LayerShortSettingDialog closeAction failuer');
      }
    }
  };


  /**
   * 保存処理
   */
  const saveAction = () => {
    //未編修なら実行しない
    if (props.editData.IsUpdate === false) {
      console.debug("LayerShortSettingDialog not edited");
      return;
    }

    //保存前チェック
    if (!checkInputData(devRow)) {
      return;
    }
    setDlgmsg(t('LayerShortSettingDialog.保存しますか?', '保存しますか?'));
    actCfmDlg
      .open()
      .apply((_) => {
        setButtonEnable(false);
        saveProc(devRow).finally(() => {
          setButtonEnable(true);
        });
      })
      .cancel(() => { });
  }

  /**
   * 保存
   */
  const saveProc = (target: object): Promise<string> => {
    return new Promise((resolve, reject) => {
      const devItem = target as NAME_DEV_SET;
      if (devItem) {
        SetNameDevSetRow(devRow)
          .then((res) => {
            console.debug(`LayerShortSettingDialog SetNameDevSetRow res : ${res}`);
            if (res.ErrorCode === ErrorCode.ERR_CODE_NONE) {

              //判定値設定に移動平均法を追加・書換
              SetJudgeSettingLayerShort(devItem.DEV_INDEX)
                .then((res2) => {
                  console.debug(`LayerShortSettingDialog SetLayerShortItem res : ${res2}`);
                  if (res2.ErrorCode == ErrorCode.ERR_CODE_NONE) {
                    props.editData.IsUpdate = false;
                    setIsUpdateDisp(!isUpdateDisp);
                    setDlgmsg(t('LayerShortSettingDialog.保存が完了しました\nダイアログを閉じますか', '保存が完了しました\nダイアログを閉じますか'));
                    actCfmDlg
                      .open()
                      .apply((_) => {
                        props.editData.IsUpdate = false;
                        console.debug(t('LayerShortSettingDialog.実行', '実行'));

                        if (props.editData.CloseDialog !== undefined) {
                          console.debug('LayerShortSettingDialog closeAction complete');
                          props.editData.CloseDialog();
                        }
                        else {
                          console.debug('LayerShortSettingDialog closeAction failuer');
                        }
                      })
                      .cancel(() => {
                        console.debug(t('LayerShortSettingDialog.キャンセル', 'キャンセル'));
                      });

                    // props.editData.CloseSetting();
                    resolve('done');
                  } else {
                    if (res2.ErrorCode === ErrorCode.ERR_CODE_JSET_MOVE_AVERAGE_ADD_CHANGE) {
                      if (res2.ErrorMessage == "移動平均の追加に失敗しました") {
                        setDlgmsg(t('LayerShortSettingDialog.移動平均の追加に失敗しました', '移動平均の追加に失敗しました'));
                        actMsgDlg.open();
                        console.error(['LayerShortSettingDialog Moving average addition failure']);
                        reject('data error');
                      }
                      else {
                        //res2.ErrorMessageにPLC_NOとAI_CARD、AI_CHが渡ってきている
                        setDlgmsg(res2.ErrorMessage + t('LayerShortSettingDialog.に空き行がなかったため\n判定値設定に移動平均の追加ができませんでした', 'に空き行がなかったため\n判定値設定に移動平均の追加ができませんでした'));
                        actMsgDlg.open();
                        console.error(['LayerShortSettingDialog Moving average addition failure', res2.ErrorMessage]);
                        reject('data error');
                      }
                    }
                    else if (res2.ErrorCode === ErrorCode.ERR_CODE_JSET_MOVE_AVERAGE_RST) {
                      if (res2.ErrorMessage === '移動平均の行の初期化に失敗しました') {
                        setDlgmsg(t('LayerShortSettingDialog.移動平均の行の初期化に失敗しました', '移動平均の行の初期化に失敗しました'));
                        actMsgDlg.open();
                        console.error(['LayerShortSettingDialog Moving average reset failure']);
                        reject('data error');
                      }
                      else {
                        setDlgmsg(res2.ErrorMessage + t('LayerShortSettingDialog.の移動平均行の初期化に失敗しました', 'の移動平均行の初期化に失敗しました'));
                        actMsgDlg.open();
                        console.error(['LayerShortSettingDialog Moving average reset failure', res2.ErrorMessage]);
                        reject('data error');
                      }
                    }
                  }
                })
            } else {
              setDlgmsg(t('LayerShortSettingDialog.移動平均の保存に失敗しました', '移動平均の保存に失敗しました'));
              actMsgDlg.open();
              console.error(['LayerShortSettingDialog save failed']);
              reject('update fault');
            }
          })
          .catch((error) => {
            console.error('LayerShortSettingDialog SetNameDevSetRow : ' + error);
          });
      } else {
        reject('data error');
      }
    })
  }

  /**
   * タブ遷移時の保存処理
   * @param param 
   * @returns 
   */
  const saveAction2 = (param: object): Promise<string> => {
    console.debug(["--LayerShortSettingDialog saveAction2 strat--"]);
    return new Promise((resolve, reject) => {
      const devItem = param as NAME_DEV_SET;
      //保存前チェック
      if (!checkInputData(devItem)) {
        return;
      }
      setButtonEnable(false);

      SetNameDevSetRow(devItem)
        .then((r) => {
          props.editData.IsUpdate = false;
          console.debug('saveAction ok');
          resolve('done');
        })
        .catch((r) => {
          setDlgmsg(t('LayerShortSettingDialog.保存中にエラーが発生しました', '保存中にエラーが発生しました'));
          actMsgDlg.open();
          console.error(['saveAction error', r]);
          reject('data error');
        })
        .finally(() => {
          setButtonEnable(true);
        });

    })
  }

  /**
   * 入力値が奇数か確認
   * 短い窓幅と長い窓幅の大きさチェック
   * nullチェック
   * @returns 
   */
  const checkInputData = (nameDevRow: NAME_DEV_SET): boolean => {
    console.debug("LayerShortSettingDialog input check Start");
    {/**窓幅 */ }
    if (nameDevRow.SMOOTH_W0 !== null) {
      if (nameDevRow.SMOOTH_W0 < 1) {
        setDlgmsg(t('LayerShortSettingDialog.窓幅の値が最小値より小さいです', '窓幅の値が最小値より小さいです'));
        actMsgDlg.open();
        console.warn("LayerShortSettingDialog SMOOTH_W0 < minValue");
        return false;
      }
      else if (nameDevRow.SMOOTH_W0 > 199) {
        setDlgmsg(t('LayerShortSettingDialog.窓幅の値が最大値より大きいです', '窓幅の値が最大値より大きいです'));
        actMsgDlg.open();
        console.warn("LayerShortSettingDialog SMOOTH_W0 > minValue");
        return false;
      }
      if (nameDevRow.SMOOTH_W0 % 2 == 0) {
        setDlgmsg(t('LayerShortSettingDialog.窓幅の値が偶数です', '窓幅の値が偶数です。奇数を入力してください'));
        actMsgDlg.open();
        console.warn("LayerShortSettingDialog input check NG");
        return false;
      }
    }
    else {
      setDlgmsg(t('LayerShortSettingDialog.窓幅の値が空です\n値を入力してください', '窓幅の値が空です\n値を入力してください'));
      actMsgDlg.open();
      console.warn("LayerShortSettingDialog input check NG");
      return false;
    }
    {/**短い窓幅 */ }
    if (nameDevRow.SMOOTH_W1 !== null) {
      if (nameDevRow.SMOOTH_W1 < 1) {
        setDlgmsg(t('LayerShortSettingDialog.短い窓幅の値が最小値より小さいです', '短い窓幅の値が最小値より小さいです'));
        actMsgDlg.open();
        console.warn("LayerShortSettingDialog SMOOTH_W1 < minValue");
        return false;
      }
      else if (nameDevRow.SMOOTH_W1 > 199) {
        setDlgmsg(t('LayerShortSettingDialog.短い窓幅の値が最大値より大きいです', '短い窓幅の値が最大値より大きいです'));
        actMsgDlg.open();
        console.warn("LayerShortSettingDialog SMOOTH_W1 > minValue");
        return false;
      }

      if (nameDevRow.SMOOTH_W1 % 2 == 0) {
        setDlgmsg(t('LayerShortSettingDialog.短い窓幅の値が偶数です', '短い窓幅の値が偶数です。奇数を入力してください'));
        actMsgDlg.open();
        console.warn("LayerShortSettingDialog input check NG");
        return false;
      }
    }
    else {
      setDlgmsg(t('LayerShortSettingDialog.短い窓幅の値が空です\n値を入力してください', '短い窓幅の値が空です\n値を入力してください'));
      actMsgDlg.open();
      console.warn("LayerShortSettingDialog input check NG");
      return false;
    }
    {/**長い窓幅 */ }
    if (nameDevRow.SMOOTH_W2 !== null) {
      if (nameDevRow.SMOOTH_W2 < 1) {
        setDlgmsg(t('LayerShortSettingDialog.長い窓幅の値が最小値より小さいです', '長い窓幅の値が最小値より小さいです'));
        actMsgDlg.open();
        console.warn("LayerShortSettingDialog SMOOTH_W2 < minValue");
        return false;
      }
      else if (nameDevRow.SMOOTH_W2 > 199) {
        setDlgmsg(t('LayerShortSettingDialog.長い窓幅の値が最大値より大きいです', '長い窓幅の値が最大値より大きいです'));
        actMsgDlg.open();
        console.warn("LayerShortSettingDialog SMOOTH_W2 > minValue");
        return false;
      }

      if (nameDevRow.SMOOTH_W2 % 2 == 0) {
        setDlgmsg(t('LayerShortSettingDialog.長い窓幅の値が偶数です', '長い窓幅の値が偶数です。奇数を入力してください'));
        actMsgDlg.open();
        console.warn("LayerShortSettingDialog input check NG");
        return false;
      }
    }
    else {
      setDlgmsg(t('LayerShortSettingDialog.長い窓幅の値が空です\n値を入力してください', '長い窓幅の値が空です\n値を入力してください'));
      actMsgDlg.open();
      console.warn("LayerShortSettingDialog input check NG");
      return false;
    }
    {/**閾値xσ */ }
    if (nameDevRow.TH_SIGMA === null) {
      setDlgmsg(t('LayerShortSettingDialog.閾値xσが空です\n値を入力してください', '閾値xσが空です\n値を入力してください'));
      actMsgDlg.open();
      console.warn("LayerShortSettingDialog input check NG");
      return false;
    }
    else {
      if (nameDevRow.TH_SIGMA < 0.01) {
        setDlgmsg(t('LayerShortSettingDialog.閾値xσの値が最小値より小さいです', '閾値xσの値が最小値より小さいです'));
        actMsgDlg.open();
        console.warn("LayerShortSettingDialog TH_SIGMA < minValue");
        return false;
      }
      else if (nameDevRow.TH_SIGMA > 9.99) {
        setDlgmsg(t('LayerShortSettingDialog.閾値xσの値が最大値より大きいです', '閾値xσの値が最大値より大きいです'));
        actMsgDlg.open();
        console.warn("LayerShortSettingDialog TH_SIGMA > minValue");
        return false;
      }
    }
    {/**軽故障閾値R相 */ }
    if (nameDevRow.TH_L_R !== null) {
      if (nameDevRow.TH_L_R < 0.1) {
        setDlgmsg(t('LayerShortSettingDialog.軽故障R相の値が最小値より小さいです', '軽故障R相の値が最小値より小さいです'));
        actMsgDlg.open();
        console.warn("LayerShortSettingDialog TH_L_R < minValue");
        return false;
      }
      else if (nameDevRow.TH_L_R > 99.9) {
        setDlgmsg(t('LayerShortSettingDialog.軽故障R相の値が最大値より大きいです', '軽故障R相の値が最大値より大きいです'));
        actMsgDlg.open();
        console.warn("LayerShortSettingDialog TH_L_R > minValue");
        return false;
      }
    }
    // else{
    //   setDlgmsg(t('LayerHortSettingDialog.軽故障閾値R相が空です\n値を入力してください', '軽故障閾値R相が空です\n値を入力してください'));
    //   actMsgDlg.open();
    //   console.warn("LayerShortSettingDialog input check NG");
    //   return false;
    // }

    {/**軽故障閾値S相 */ }
    if (nameDevRow.TH_L_S !== null) {
      if (nameDevRow.TH_L_S < 0.1) {
        setDlgmsg(t('LayerShortSettingDialog.軽故障S相の値が最小値より小さいです', '軽故障S相の値が最小値より小さいです'));
        actMsgDlg.open();
        console.warn("LayerShortSettingDialog TH_L_S < minValue");
        return false;
      }
      else if (nameDevRow.TH_L_S > 99.9) {
        setDlgmsg(t('LayerShortSettingDialog.軽故障S相の値が最大値より大きいです', '軽故障S相の値が最大値より大きいです'));
        actMsgDlg.open();
        console.warn("LayerShortSettingDialog TH_L_S > minValue");
        return false;
      }
    }
    // else{
    //   setDlgmsg(t('LayerHortSettingDialog.軽故障閾値S相が空です\n値を入力してください', '軽故障閾値S相が空です\n値を入力してください'));
    //   actMsgDlg.open();
    //   console.warn("LayerShortSettingDialog input check NG");
    //   return false;
    // }

    {/**軽故障閾値T相 */ }
    if (nameDevRow.TH_L_T !== null) {
      if (nameDevRow.TH_L_T < 0.1) {
        setDlgmsg(t('LayerShortSettingDialog.軽故障T相の値が最小値より小さいです', '軽故障T相の値が最小値より小さいです'));
        actMsgDlg.open();
        console.warn("LayerShortSettingDialog TH_L_T < minValue");
        return false;
      }
      else if (nameDevRow.TH_L_T > 99.9) {
        setDlgmsg(t('LayerShortSettingDialog.軽故障T相の値が最大値より大きいです', '軽故障T相の値が最大値より大きいです'));
        actMsgDlg.open();
        console.warn("LayerShortSettingDialog TH_L_T > minValue");
        return false;
      }
    }
    // else{
    //   setDlgmsg(t('LayerHortSettingDialog.軽故障閾値T相が空です\n値を入力してください', '軽故障閾値T相が空です\n値を入力してください'));
    //   actMsgDlg.open();
    //   console.warn("LayerShortSettingDialog input check NG");
    //   return false;
    // }

    {/**重故障閾値R相 */ }
    if (nameDevRow.TH_H_R !== null) {
      if (nameDevRow.TH_H_R < 0.1) {
        setDlgmsg(t('LayerShortSettingDialog.重故障R相の値が最小値より小さいです', '重故障R相の値が最小値より小さいです'));
        actMsgDlg.open();
        console.warn("LayerShortSettingDialog TH_H_R < minValue");
        return false;
      }
      else if (nameDevRow.TH_H_R > 99.9) {
        setDlgmsg(t('LayerShortSettingDialog.重故障R相の値が最大値より大きいです', '重故障R相の値が最大値より大きいです'));
        actMsgDlg.open();
        console.warn("LayerShortSettingDialog TH_H_R > minValue");
        return false;
      }
    }
    // else {
    //   setDlgmsg(t('LayerHortSettingDialog.重故障閾値R相が空です\n値を入力してください', '重故障閾値R相が空です\n値を入力してください'));
    //   actMsgDlg.open();
    //   console.warn("LayerShortSettingDialog input check NG");
    //   return false;
    // }

    {/**重故障閾値S相 */ }
    if (nameDevRow.TH_H_S !== null) {
      if (nameDevRow.TH_H_S < 0.1) {
        setDlgmsg(t('LayerShortSettingDialog.重故障S相の値が最小値より小さいです', '重故障S相の値が最小値より小さいです'));
        actMsgDlg.open();
        console.warn("LayerShortSettingDialog TH_H_S < minValue");
        return false;
      }
      else if (nameDevRow.TH_H_S > 99.9) {
        setDlgmsg(t('LayerShortSettingDialog.重故障S相の値が最大値より大きいです', '重故障S相の値が最大値より大きいです'));
        actMsgDlg.open();
        console.warn("LayerShortSettingDialog TH_H_S > minValue");
        return false;
      }
    }
    // else{
    //   setDlgmsg(t('LayerHortSettingDialog.重故障閾値S相が空です\n値を入力してください', '重故障閾値S相が空です\n値を入力してください'));
    //   actMsgDlg.open();
    //   console.warn("LayerShortSettingDialog input check NG");
    //   return false;
    // }

    {/**重故障閾値T相 */ }
    if (nameDevRow.TH_H_T !== null) {
      if (nameDevRow.TH_H_T < 0.1) {
        setDlgmsg(t('LayerShortSettingDialog.重故障T相の値が最小値より小さいです', '重故障T相の値が最小値より小さいです'));
        actMsgDlg.open();
        console.warn("LayerShortSettingDialog TH_H_T < minValue");
        return false;
      }
      else if (nameDevRow.TH_H_T > 99.9) {
        setDlgmsg(t('LayerShortSettingDialog.重故障T相の値が最大値より大きいです', '重故障T相の値が最大値より大きいです'));
        actMsgDlg.open();
        console.warn("LayerShortSettingDialog TH_H_T > minValue");
        return false;
      }
    }
    // else{
    //   setDlgmsg(t('LayerHortSettingDialog.重故障閾値T相が空です\n値を入力してください', '重故障閾値T相が空です\n値を入力してください'));
    //   actMsgDlg.open();
    //   console.warn("LayerShortSettingDialog input check NG");
    //   return false;
    // }

    if (nameDevRow.SMOOTH_W1 >= nameDevRow.SMOOTH_W2) {
      setDlgmsg(t('LayerShortSettingDialog.短い窓幅>=長い窓幅です', '短い窓幅 >= 長い窓幅です。短い窓幅 < 長い窓幅に修正してください'));
      actMsgDlg.open();
      console.warn("LayerShortSettingDialog input check NG");
      return false;
    }
    console.debug("LayerShortSettingDialog input check OK");
    return true;
  }


  return (
    <>
      {/**ボディーの呼び出し処理 */}
      {devRow.DEV_INDEX !== 0 ?
        <LayerShortSettingDialogBody
          nameDevSetRow={devRow}
          updateItem={updateDev}
        /> :
        null
      }

      <DialogActions>
        <Button
          className={pageStyle.buttonStyle}
          variant="contained"
          color="primary"
          disableElevation
          onClick={(e) => {
            saveAction();
          }}
        >
          {t('LayerShortSettingDialog.保存', '保存')}
        </Button>
        <Button
          className={pageStyle.buttonStyle}
          variant="contained"
          color="primary"
          disableElevation
          onClick={() => {
            cancelAction();
          }}
        >
          {t('LayerShortSettingDialog.キャンセル', 'キャンセル')}
        </Button>
      </DialogActions>
      {cfmdlg}
      {msgdlg}
    </>
  )
}

export default LayerShortSettingDialog;